var watchlistEdit = {
	confirmBtn: "Ok",
	cancelBtn: "Cancelar",
	title: "Editar lista de seguimiento",
	nameInputLabel: "Nombre de la lista de seguimiento",
	nameInputTip: "Máximo 100 caracteres – Caracteres válidos: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ",
	placeholder: "Nuevo nombre",
	validationErrors: {
		name: {
			invalidInput: "El nombre no es válido. Máximo 100 caracteres – Caracteres válidos: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ"
		}
	}
};
var es = {
	watchlistEdit: watchlistEdit
};

export { es as default, watchlistEdit };
